// ** React Imports
import { useContext, useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { AbilityContext } from '@src/utility/context/Can';

// ** Custom Components
import Avatar from '@components/avatar';

// ** Utils
import { isUserLoggedIn } from '@utils';

// ** Store & Actions
import { useDispatch } from 'react-redux';
import { handleLogout } from '@store/actions/auth';

// ** Third Party Components
import {
	UncontrolledDropdown,
	DropdownMenu,
	DropdownToggle,
	DropdownItem
} from 'reactstrap';
import {
	User,
	Mail,
	CheckSquare,
	MessageSquare,
	Settings,
	CreditCard,
	HelpCircle,
	Power,
	ChevronDown,
	DownloadCloud,
	Loader,
	List,
	Map,
	Key
} from 'react-feather';

// ** Default Avatar Image
import defaultAvatar from '@src/assets/images/portrait/small/avatar-s-11.jpg';
import NiceModal from '@ebay/nice-modal-react';
const UserDropdown = () => {
	const history = useHistory();
	const ability = useContext(AbilityContext);
	// ** Store Vars
	const dispatch = useDispatch();

	// ** State
	const [userData, setUserData] = useState(null);

	//** ComponentDidMount
	useEffect(() => {
		if (isUserLoggedIn() !== null) {
			const userData = JSON.parse(localStorage.getItem('userData'));
			setUserData(userData);
		}
	}, []);

	//** Vars
	const userAvatar = (userData && userData.avatar) || defaultAvatar;
	return (
		<UncontrolledDropdown tag="li" className="dropdown-user nav-item">
			<DropdownToggle
				href="/"
				tag="a"
				className="nav-link dropdown-user-link"
				onClick={(e) => e.preventDefault()}
			>
				<Avatar
					content={userData && userData['name'][0] + userData['name'][1]}
					status="online"
					color="info"
				/>
				<div className="user-nav d-sm-flex d-none">
					<span
						style={{
							paddingLeft: '5px',
							paddingTop: '5px',
							fontFamily: 'Poppins Medium',
							color: '#021E43'
						}}
						className="user-name "
					>
						{userData && userData['name']}
					</span>
				</div>
				<ChevronDown size={20} />
			</DropdownToggle>
			<DropdownMenu right>
				<DropdownItem
					tag={Link}
					to="#"
					onClick={() => {
						const userData = localStorage.getItem('userData');
						localStorage.clear();
						localStorage.setItem('userData', userData);
						location.reload();
					}}
				>
					<Loader size={14} className="mr-75" />
					<span className="align-middle">Recargar catálogos</span>
				</DropdownItem>
				<DropdownItem
					tag={Link}
					onClick={async () => {
						const result = await NiceModal.show('seleccionar-mi-modulo');
					}}
				>
					<Map size={14} className="mr-75" />
					<span className="align-middle">Seleccionar módulo</span>
				</DropdownItem>
				<DropdownItem tag={Link} onClick={() => history.push('/configuracion')}>
					<Settings size={14} className="mr-75" />
					<span className="align-middle">Configuracion</span>
				</DropdownItem>
				<DropdownItem
					tag={Link}
					onClick={() => history.push('/change_password')}
				>
					<Key size={14} className="mr-75" />
					<span className="align-middle">Cambiar Contraseña</span>
				</DropdownItem>
				<DropdownItem
					tag={Link}
					to="/login"
					onClick={() => dispatch(handleLogout())}
				>
					<Power size={14} className="mr-75" />
					<span className="align-middle">Logout</span>
				</DropdownItem>
			</DropdownMenu>
		</UncontrolledDropdown>
	);
};

export default UserDropdown;
